import styles from './ListSkeleton.module.css';

export default function ListSkeleton(){
    return(
        <div className={styles['item']}>   
            <div/>
            <div/>
        </div>
    )
}